import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader.tsx";
import { lazy, Suspense } from "react";

const RespirationHistoryPage = lazy(
  () => import("./RespirationHistoryPage.tsx"),
);

function RespirationHistoryPageLazy() {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <RespirationHistoryPage />
    </Suspense>
  );
}

export default RespirationHistoryPageLazy;
